import React, { useEffect, useState } from 'react';
import styles from './SellerDashboard.module.scss';
import { Button, Col, Container, Row } from 'reactstrap';
import RecentOrderTable from '../../../components/SellerPortalComponents/RecentOrderTable/RecentOrderTable';
import CampaignCard from '../../../components/SellerPortalComponents/CampaignCard/CampaignCard';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { CircularProgressbar } from 'react-circular-progressbar'; 
import 'react-circular-progressbar/dist/styles.css';
import { data, discountPromotions, financialData, headers, loyaltyData, maelanoUniData, productStatusData, progressData, recentReviewsData, socialMediaData, supportData, topSellingProducts, upcomingEvent } from './dashboardData';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { TiArrowBack } from "react-icons/ti";
import { setApproved } from '../../../utility/api/services/fbmApprovalSlice/approvalFbmSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const SellerDashboard = () => {
    const { isApproved } = useSelector((state) => state.fbmApproval);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [showAllProducts, setShowAllProducts] = useState(false);

    const visiblePromotions = showAll ? discountPromotions : discountPromotions.slice(0, 4);

    const visibleProducts = showAllProducts ? productStatusData : productStatusData.slice(0, 5);

    useEffect(() => {
        if (isApproved) {
            dispatch(setApproved(false));
            navigate("/dashboard");
        }
    }, [isApproved]);

    return (
        <div className={styles.mainDashboardContainer}>

            {/* Store Details Header Section */}
            <Container fluid className={styles.header}>
                <Row className={`${styles.headerRow} gy-2 gy-lg-0`}>
                    <Col xs='12' lg="4" className={styles.storeColumn}>
                        <div className={styles.storeInfo}>
                            <div className={styles.storeDetails}>
                                <img src={require("../../../assets/images/SellerPortalImages/DashboardImages/StoreLogo.png")} alt="Store Logo" className={styles.storeLogo} />
                                <div>
                                    <p className={styles.storeName}>Store name</p>
                                    <p className={styles.location}>Location</p>
                                    <p className={styles.followers}>1k followers</p>
                                </div>
                            </div>
                            <Button type="button" color='link' className={styles.editBtn}>Edit Profile</Button>
                        </div>
                    </Col>
                    <Col xs='12' lg="8" className={styles.announcements}>
                        <h4>Announcements</h4>
                        <p>New updates are coming soon!</p>
                    </Col>
                </Row>
            </Container>

            {/* Overview Panel Section */}
            <h4 className={styles.sectionHeading}>Overview Panel</h4>

            <Container fluid className={styles.overviewPanel}>
                <Row className={styles.overviewPanelRow}>
                    <Col md="5" className={styles.salesSummary}>
                        <h5 className={styles.subSectionHeading}>Sales Summary</h5>
                        <Row className="g-2">
                            <Col className="d-grid">
                                <div className={styles.card}><span>$5500 </span>Today Sales</div>
                            </Col>
                            <Col className="d-grid">
                                <div className={styles.card}><span>$40,000 </span>Total Earnings</div>
                            </Col>
                            <Col className='d-grid'>
                                <div className={styles.card}><span>60 </span>Total Orders</div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="7" className={styles.performanceMetrics}>
                        <h5 className={styles.subSectionHeading}>Performance Metrices</h5>
                        <Row className="g-0">
                            <Col sm='12' lg="8">
                                <Row className="g-0 row-gap-3">
                                    <Col md="6" className="pe-3 d-grid">
                                        <div className={styles.card}><span>20% </span>Conversion Rate</div>
                                    </Col>
                                    <Col md="6" className="pe-3 d-grid">
                                        <div className={styles.card}><span>$300 </span>Average order value</div>
                                    </Col>
                                    <Col md="6" className="pe-3 d-grid">
                                        <div className={styles.card}><span>1% </span>Return Rate</div>
                                    </Col>
                                    <Col md="6" className="pe-3 d-grid">
                                        <div className={styles.card}><span>100% </span>Customer Satisfaction</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm='12' lg="4">
                                <div className={styles.imgContainer}>
                                    <img src={require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/PerformanceGraph.png")} alt="Performance Graph" className={styles.graphImg} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className={styles.recentOrdersRow}>
                    <h5 className={styles.recentOrderHeading}>Recent Orders</h5>
                    <Col sm='12' lg="9" className='pe-3'>
                        <RecentOrderTable headers={headers} data={data} />
                    </Col>
                    <Col sm='12' lg="3" className='px-3'>
                        <Container className={styles.sidePanel}>
                            <Row className='g-0'>
                                <Col className={styles.infoCard}>
                                    <div><span>30 </span>Ready to ship</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className={styles.infoCard}>
                                    <div><span>6 </span>Pending Returns</div>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>

            {/* Marketing and Promotion Insights Section */}
            <h4 className={styles.sectionHeading}>Marketing and Promotion Insights</h4>

            <Container fluid className={styles.insightsContainer}>
                {/* Current Campaigns Section */}
                <Row className={styles.campaignRow}>
                    <h5 className={styles.insightSubHeading}>Current Campaigns</h5>
                    <Col xs="12" md="6" lg='4' className={styles.campaignColumn}>
                        <Row className="g-0">
                            <Col xs="12" className={styles.campaignStatsColumn}>
                                <div className={styles.campaignStatsText}>Click-through rate: <span>50%</span></div>
                                <div className={styles.campaignStatsText}>Conversion Rate: <span>20%</span></div>
                            </Col>
                            <Col xs="12" className={styles.campaignCardColumn}>
                                <CampaignCard
                                    title="Summer Sale"
                                    startDate="04/06/2024"
                                    endDate="15/06/2024"
                                    active={isActive}
                                    setIsActive={setIsActive}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" md="6" lg='4' className={styles.campaignColumn}>
                        <Row className="g-0">
                            <Col xs="12" className={styles.campaignStatsColumn}>
                                <div className={styles.campaignStatsText}>Click-through rate: <span>50%</span></div>
                                <div className={styles.campaignStatsText}>Conversion Rate: <span>20%</span></div>
                            </Col>
                            <Col xs="12" className={styles.campaignCardColumn}>
                                <CampaignCard
                                    title="Summer Sale"
                                    startDate="04/06/2024"
                                    endDate="15/06/2024"
                                    active={isActive}
                                    setIsActive={setIsActive}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" md="6" lg='4' className={styles.campaignColumn}>
                        <Row className="g-0">
                            <Col xs="12" className={styles.campaignStatsColumn}>
                                <div className={styles.campaignStatsText}>Click-through rate: <span>50%</span></div>
                                <div className={styles.campaignStatsText}>Conversion Rate: <span>20%</span></div>
                            </Col>
                            <Col xs="12" className={styles.campaignCardColumn}>
                                <CampaignCard
                                    title="Summer Sale"
                                    startDate="04/06/2024"
                                    endDate="15/06/2024"
                                    active={isActive}
                                    setIsActive={setIsActive}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Upcoming Events Section */}
                <Row className={styles.eventRow}>
                    <h5 className={styles.insightSubHeading}>Upcoming Events</h5>
                    {upcomingEvent.map((eventItem, eventIndex) => (
                        <Col key={eventIndex} xs="12" md="6" className={styles.eventColumn}>
                            <Row className={styles.eventCardRow}>
                                <Col xs='0' lg="4" className={styles.eventImgColumn}>
                                    <img src={eventItem.src} alt={eventItem.title} className={`${styles.eventImg} img-fluid`} />
                                </Col>
                                <Col xs='12' lg="8" className={styles.eventContentColumn}>
                                    <h5>{eventItem.title}</h5>
                                    <p className={styles.eventStartDate}>Starting on {eventItem.startDate}</p>
                                    <p className={styles.eventDuration}>{eventItem.duration} duration</p>
                                    <button type="button" className={styles.participateBtn}>
                                        Participate now <MdKeyboardDoubleArrowRight size={25} className={styles.doubleArrowIcon} />
                                    </button>
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>

                {/* Discounts and Promotions Section */}
                <Row className={styles.discountRow}>
                    <h5 className={styles.insightSubHeading}>Discounts and Promotions</h5>
                    <div className={`${styles.promotionContainer} ${showAll ? styles.showAll : ''}`}>
                        {visiblePromotions.map((item, index) => (
                            <Col key={index} xs="12" md="4" lg="2" className={styles.discountColumn}>
                                <div className={styles.discountInfoCard}>
                                    <span>{item.count}</span> {item.label}
                                </div>
                            </Col>
                        ))}
                        {discountPromotions.length > 4 && !showAll && (
                            <Col xs="12" sm="4" md="2" className={styles.discountButtonColumn}>
                                <button
                                    className={styles.viewAllButton}
                                    onClick={() => setShowAll(true)}
                                >
                                    View All Promotions
                                </button>
                            </Col>
                        )}
                    </div>
                </Row>
            </Container>

            {/* Customer Engagement Section */}
            <h4 className={styles.sectionHeading}>Customer Engagement</h4>

            <Container fluid className={styles.customerEngagementContainer}>
                {/* Reviews Section */}
                <Row className={styles.customerEngagementRow}>
                    <Col xs='12' lg="3" className={styles.reviewColumn}>
                        <h5 className={styles.customerEngagementSubHeading}>Product Reviews</h5>
                        <Row className=''>
                            {progressData.map((data, idx) => (
                                <Col key={idx} className={styles.progressContainer}>
                                    <CircularProgressbar
                                        value={data.value}
                                        text={
                                            <tspan>
                                                <tspan x="50%" dy="-0.8em">{data.value}%</tspan>
                                                <tspan x="50%" dy="1.2em">{data.text}</tspan>
                                            </tspan>
                                        }
                                        strokeWidth={12}
                                        styles={{
                                            path: {
                                                stroke: data.color, // Set the path color
                                                strokeWidth: 12, // Set the width of the progress path (colored part)
                                            },
                                            trail: {
                                                stroke: data.color, // Set the trail color
                                                strokeWidth: 3, // Set the width of the trail (background part)
                                            },
                                            text: {
                                                fill: data.color,
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                textAnchor: 'middle', // Center the text
                                                dominantBaseline: 'middle', // Align the text vertically in the middle
                                            },
                                        }}
                                    />

                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col xs='12' lg="3" className={styles.reviewColumn}>
                        <h5 className={styles.customerEngagementSubHeading}>Seller Reviews</h5>
                        <Row className=''>
                            {progressData.map((data, idx) => (
                                <Col key={idx} className={styles.progressContainer}>
                                    <CircularProgressbar
                                        className={styles.CircularProgressbar}
                                        value={data.value}
                                        text={
                                            <tspan>
                                                <tspan x="50%" dy="-0.8em">{data.value}%</tspan>
                                                <tspan x="50%" dy="1.2em">{data.text}</tspan>
                                            </tspan>
                                        }
                                        strokeWidth={12}
                                        styles={{
                                            path: {
                                                stroke: data.color, // Set the path color
                                                strokeWidth: 12, // Set the width of the progress path (colored part)
                                            },
                                            trail: {
                                                stroke: data.color, // Set the trail color
                                                strokeWidth: 3, // Set the width of the trail (background part)
                                            },
                                            text: {
                                                fill: data.color,
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                textAnchor: 'middle', // Center the text
                                                dominantBaseline: 'middle', // Align the text vertically in the middle
                                            },
                                        }}
                                    />

                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col xs='12' lg="6" className={styles.recentReviewColumn}>
                        <Row className={styles.reviewBoxRow}>
                            <h5 className={styles.customerEngagementSubHeading}>Recent Reviews</h5>
                            {recentReviewsData.map((review, idx) => (
                                <Col key={idx} className={styles.reviewContentColumn}>
                                    <div className={styles.recentReviewHeader}>
                                        <p className={styles.reviewerName}>{review.name} <span>{review.time}</span></p>
                                        <div className={styles.reviewerRating}>
                                            {Array.from({ length: 5 }).map((_, i) => (
                                                i < review.rating ? <FaStar key={i} size={20} color="#FBBD34" /> : <FaRegStar key={i} size={20} />
                                            ))}
                                            <span>({review.rating})</span>
                                        </div>
                                    </div>
                                    <p className={styles.reviewText}>{review.review}</p>
                                    <div className={styles.replyBtnContainer}>
                                        <Button type="button" color='link' className={styles.replyBtn}>
                                            <TiArrowBack size={20} className={styles.replyBackArrow} />
                                            Reply
                                        </Button>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>

                {/* Loyalty Program Section */}
                <Row className={`${styles.loyaltyProgramRow} g-2 g-lg-0`}>
                    <h5 className={styles.customerEngagementSubHeading}>Loyalty Program</h5>
                    {loyaltyData.map((item, index) => (
                        <Col key={index} xs="12" md="4" lg="2" className={styles.loyaltyColumn}>
                            <div className={styles.loyaltyInfoCard}>
                                <span>{item.value}</span> {item.label}
                            </div>
                        </Col>
                    ))}
                </Row>

                {/* Social Media Insights Section */}
                <Row className={`${styles.socialMediaRow} g-2`}>
                    <h5 className={styles.customerEngagementSubHeading}>Social Media Insights</h5>
                    {socialMediaData.map((social, index) => (
                        <Col sm='6' lg="3" key={index} className={styles.socialMediaColumn}>
                            <Row className={styles.mediaImagesRow}>
                                <Col md="6" className={styles.platformImgColumn}>
                                    <div className={styles.platformImgContainer}>
                                        <img src={social.imgSrc} alt={`Image ${index + 1}`} className={styles.platformImg} />
                                    </div>
                                </Col>
                                <Col md="6" className={styles.likesCommentsColumn}>
                                    <Row className={styles.likesCommentsRow}>
                                        <Col md="4" className={styles.iconsContainer}>
                                            {social.icons?.map((IconImage, iconIndex) => (
                                                <div key={iconIndex}>
                                                    <IconImage size={18} />
                                                </div>
                                            ))}
                                        </Col>
                                        <Col md="8" className={styles.iconsValueContainer}>
                                            {social.iconValue.map((value, iconIndex) => (
                                                <div key={iconIndex}>
                                                    {value}
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={styles.followersRow}>
                                <Col className={styles.loyaltyColumn}>
                                    <div className={styles.loyaltyInfoCard}>
                                        {social.label} <span>{social.count}</span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Products Performance Section */}
            <h4 className={styles.sectionHeading}>Products Performance</h4>

            <Container fluid className={styles.productPerformanceContainer}>
                {/* Products Status Section */}
                <Row className={styles.productStatusRow}>
                    <h5 className={styles.productStatusSubHeading}>Products Status</h5>
                    <div className={`${styles.productStatusContainer} ${showAllProducts ? styles.showAllProduct : ''}`}>
                        {visibleProducts.map((item, index) => (
                            <Col key={index} xs="12" md="4" lg="2" className={`${styles.productStatusColumn} d-grid`}>
                                <div className={styles.statusInfoCard}>
                                    <span>{item.count}</span> {item.label}
                                </div>
                            </Col>
                        ))}
                        {productStatusData.length > 5 && !showAllProducts && (
                            <Col xs="12" sm="4" md="2" className={styles.productStatusButtonColumn}>
                                <button
                                    className={styles.viewAllProductButton}
                                    onClick={() => setShowAllProducts(true)}
                                >
                                    View Products
                                </button>
                            </Col>
                        )}
                    </div>
                </Row>

                {/* Top Selling Products Section */}
                <Row className={styles.topSellingRow}>
                    <h5 className={styles.productStatusSubHeading}>Top Selling Products</h5>
                    {topSellingProducts.map((product, productIndex) => (
                        <Col xs='12' lg="6" className={styles.topSellingColumn}>
                            <Row key={productIndex} className={styles.sellingProductsRow}>
                                <Col md="2" className={styles.sellingProductFirstColumn}>
                                    <div className={styles.productImgContainer}>
                                        <img src={product.imgSrc} alt={product.title} className={styles.productImg} />
                                    </div>
                                </Col>
                                <Col md="4" className={styles.sellingProductSecondColumn}>
                                    <p>{product.title}</p>
                                    <p className={styles.productAmount}>{product.amount}</p>
                                    <p className={styles.productQuantity}>({product.quantity})</p>
                                </Col>
                                <Col md="4" className={styles.sellingProductThirdColumn}>
                                    <Row className={styles.productLabelRow}>
                                        {product.statusLabels.map((item, index) => (
                                            <Col key={index}>
                                                <p>{item}</p>
                                            </Col>
                                        ))}
                                    </Row>
                                    <Row className={styles.productValueRow}>
                                        {product.statusCounts.map((item, index) => (
                                            <Col key={index}>
                                                <p>{item}</p>
                                            </Col>
                                        ))}
                                    </Row>

                                </Col>
                                <Col md="2" className={styles.sellingProductFourthColumn}>
                                    <product.graphIcon size={24} />
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Financial Overview Section */}
            <h4 className={styles.sectionHeading}>Financial Overview</h4>

            <Container fluid className={styles.financialOverviewContainer}>
                <Row className={styles.financialRow}>
                    {financialData.map((item, index) => (
                        <Col key={index} xs='6' lg="4" className={styles.financialColumn}>
                            <p className={styles.financialHeading}>{item.heading}</p>
                            <Row className={styles.financialStatsRow}>
                                <Col className={styles.financialInfoCard}>
                                    <span>{item.firstStat.value}</span> {item.firstStat.label}
                                    <p className={styles.cardPercentage}>{item.firstStat.percent}</p>
                                </Col>
                                <Col className={styles.financialInfoCard}>
                                    <span>{item.secondStat.value}</span> {item.secondStat.label}
                                    <p className={styles.cardPercentage}>{item.secondStat.percent}</p>
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Support and Resources Section */}
            <h4 className={styles.sectionHeading}>Support and Resources</h4>

            <Container fluid className={styles.resourcesContainer}>
                <Row className={styles.resourcesRow}>
                    {supportData.map((item, index) => (
                        <Col xs='6' lg="3" key={index} className={styles.resourcesColumns}>
                            <div className={styles.resourcesWrapper}>
                                <div className={styles.imageContainer}>
                                    <img src={item.imgSrc} alt={`${item.heading} Image`} className={styles.resourceImg} />
                                </div>
                                <p className={styles.resourceText}>{item.heading}</p>
                            </div>
                        </Col>
                    ))}
                </Row>

                <h5 className={styles.maelanoUniHeading}>Maelano University</h5>

                <Row className={styles.maelanoUniRow}>
                    {maelanoUniData.map((articleItem, index) => (
                        <Col key={index} className={styles.maelanoUniCard}>
                            <div className={styles.cardContainer}>
                                <img src={articleItem.imgSrc} alt={articleItem.title} />
                                <div className={styles.cardContent}>
                                    <p className={styles.cardHeading}>{articleItem.heading}</p>
                                    <p className={styles.cardTitle}>{articleItem.title}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    )
}

export default SellerDashboard;
